// src/components/GoogleSignInButton.js
import React, { useState } from "react";
import {Button, Spinner, Image, useToast, Icon} from "@chakra-ui/react";
import {useServerIP} from "../../../redux/ServerIPContext";
import axios from "axios";
import { FcGoogle } from "react-icons/fc";

const googleLogo =
    "https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg";

export const GoogleSignInButton = ({type}) => {
    const [loading, setLoading] = useState(false);
    const toast = useToast();
    const { serverIPs, setServerIPs, isDev } = useServerIP();

    const handleSignIn = async () => {
        setLoading(true);
        try {
            const response = await axios.post(serverIPs.SERVER_IP + '/signin_with_google', {
            });

            console.log("Response from Google sign-in endpoint:", response)
            if (response.data.status !== 200) {
                toast({
                    title: "Google Sign-In failed",
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                });
                setLoading(false);
            } else {
                const authorization_url = response.data.message.authorization_url;
                const state = response.data.message.state;
                console.log("GOT HERE AUTHORIZATION URL", authorization_url);
                window.location.href = authorization_url;
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
            toast({
                title: "Google Sign-In failed",
                status: "error",
                duration: 5000,
                isClosable: true,
            });
            setLoading(false);
        }
    };

    return (
        <Button
            onClick={handleSignIn}
            isLoading={loading}
            spinner={<Spinner />}
            position="relative"         /* make this a positioning context */
            variant="outline"
            width={type === "signup" ? '95%' : '100%'}

            /* symmetrical horizontal padding so text centering is exact */
            px={8}                      /* adjust as needed (8 => 2rem) */
            py={5}

            justifyContent="center"     /* center the text inside the content box */

            /* your other styles */
            fontWeight={475}
            fontSize={15.5}
            color="black"
            borderRadius={8}
            borderColor="rgba(220, 220, 224, 1)"
            borderWidth={1}
            _hover={{ bg: "rgba(245, 245, 245, 1)" }}
        >
            {/* absolutely‐position the Google icon into the left padding */}
            <Icon
                as={FcGoogle}
                boxSize={6}               /* change this to resize the icon */
                position="absolute"
                left={4}                  /* same scale as px—4 => 1rem in from the left edge */
                top="50%"
                transform="translateY(-50%)"
            />

            {/* this text is now perfectly centered */}
            {type === "signup" ? "Sign up with Google" : "Sign in with Google"}
        </Button>
    );
}
